import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { AggregatorRouteImplementationService } from './api/aggregatorRouteImplementation.service';
import { PlatformResourcesService } from './api/platformResources.service';
import { PlatformSubscriptionService } from './api/platformSubscription.service';
import { RcsAgentsService } from './api/rcsAgents.service';
import { RouteCreationService } from './api/routeCreation.service';
import { RouteCredentailsService } from './api/routeCredentails.service';
import { RouteGroupService } from './api/routeGroup.service';
import { RouteMapService } from './api/routeMap.service';
import { SMPPClientCredentialService } from './api/sMPPClientCredential.service';
import { SMPPConnectionsService } from './api/sMPPConnections.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: [
    AggregatorRouteImplementationService,
    PlatformResourcesService,
    PlatformSubscriptionService,
    RcsAgentsService,
    RouteCreationService,
    RouteCredentailsService,
    RouteGroupService,
    RouteMapService,
    SMPPClientCredentialService,
    SMPPConnectionsService ]
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
